/* RESPONSIBLE TEAM: team-actions */
import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

class AutomationFinAIAgentProcedureSectionRoute extends Route {
  reactEnabled() {
    return true;
  }
}

export default ReactRoute(AutomationFinAIAgentProcedureSectionRoute, {
  overrideRenderTemplate: false,
});
